import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import { StatusType } from './status-types'
import statusSlice from './status-slice'
import { StructuredError } from 'types/error'

const STATUS_TIMEOUT = 3000

const useStatus = () => {
  const status = useSelector((state: RootState) => state.status)

  const dispatch = useDispatch<TypedDispatch<RootState>>()

  return useMemo(
    () => ({
      type: status.status,
      error: status.error,
      set: (status: StatusType, error?: string | StructuredError) => {
        dispatch(statusSlice.actions.setStatus({ status, error: error }))

        // Remove the status after 3 seconds
        setTimeout(() => {
          dispatch(statusSlice.actions.resetStatus())
        }, STATUS_TIMEOUT)
      },
    }),
    [status, dispatch],
  )
}

export default useStatus
